import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../models/api.model';
import { Payment, PaymentCreate } from '../models/payment.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private apiUrl = `${environment.apiUrl}/booking/payments/`;

  constructor(private http: HttpClient) {}

  list(rentalId?: number): Observable<PaginatedResponse<Payment>> {
    let params = new HttpParams();
    if (rentalId) {
      params = params.set('rental', rentalId.toString());
    }
    return this.http.get<PaginatedResponse<Payment>>(this.apiUrl, { params });
  }

  create(data: PaymentCreate): Observable<Payment> {
    return this.http.post<Payment>(this.apiUrl, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}/`);
  }
}
